var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "group-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 149.78 133.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "group_add_FILL0_wght700_GRAD200_opsz24",
    "data-name": "cls-1",
    d: "M59.57,65.78a31.79,31.79,0,0,1-23.34-9.63A31.88,31.88,0,0,1,26.6,32.73,31.35,31.35,0,0,1,36.23,9.47,32.12,32.12,0,0,1,59.66,0,31.65,31.65,0,0,1,82.91,9.46,31.69,31.69,0,0,1,92.37,32.8a32.1,32.1,0,0,1-9.45,23.34,31.43,31.43,0,0,1-23.35,9.64ZM0,133.67V107.72A26.52,26.52,0,0,1,3.7,93.93a23.66,23.66,0,0,1,10.17-9.39A103.25,103.25,0,0,1,36.3,76.22a98.38,98.38,0,0,1,23.18-2.77,99.85,99.85,0,0,1,23.6,2.77,101.57,101.57,0,0,1,22,8.16,24.7,24.7,0,0,1,10.27,9.34,26.14,26.14,0,0,1,3.77,14v26ZM59.57,43.58a10,10,0,0,0,7.51-3.17,10.8,10.8,0,0,0,0-15.19A10.16,10.16,0,0,0,59.58,22,10.31,10.31,0,0,0,52,25.26a10.6,10.6,0,0,0,0,15.15,10.33,10.33,0,0,0,7.59,3.17ZM22,111.48H96.92v-2.94a5.3,5.3,0,0,0-.79-2.9A4.55,4.55,0,0,0,94,103.81a82.15,82.15,0,0,0-16.73-6,75.25,75.25,0,0,0-17.74-2.12,78.54,78.54,0,0,0-18,2.12,71.06,71.06,0,0,0-16.53,6,4.55,4.55,0,0,0-2.14,1.83,5.3,5.3,0,0,0-.79,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "cls-2",
    d: "M92.79,65.25A42.09,42.09,0,0,0,102.74,50a49.47,49.47,0,0,0,3.11-17.27,46.18,46.18,0,0,0-3.59-17.63A43.27,43.27,0,0,0,92.47.29,31.58,31.58,0,0,1,113.36,12,33.65,33.65,0,0,1,113,54,30.16,30.16,0,0,1,92.79,65.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "cls-2",
    d: "M132.45,133.63V107a39.24,39.24,0,0,0-2.67-15A36.36,36.36,0,0,0,121.7,80.1a41.43,41.43,0,0,1,20.16,9.22A22.45,22.45,0,0,1,149.77,107v26.6Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.5d53353ff54dfed0519965b71717812b.svg";
export { ForwardRef as ReactComponent };